import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://rondori.com/api/v1'
});

instance.interceptors.response.use((response) => {
  return response;
}, (error) => {
  console.log('err',error.response)
  if (error.response.status === 401) {
    localStorage.removeItem("rondori_token")
    localStorage.removeItem("rondori_user")
    localStorage.removeItem("rondori_credit")

    window.location.replace('/')
  }
  return Promise.reject(error);
});

export default instance;